"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Textarea = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var getTextareaBlockPadding = function getTextareaBlockPadding(size) {
  return size === 'small' ? (0, _index.cssSpacing)('tighter-2', '8px') : (0, _index.cssSpacing)('tighter', '12px');
};
var Textarea = exports.Textarea = _styledComponents["default"].textarea.withConfig({
  displayName: "Textarea",
  componentId: "sc-7bfmzb-0"
})(["", ";", ";margin-block:0;border-radius:", ";padding-block:", ";padding-inline:", ";", ";"], function (props) {
  return (0, _index.formControlBase)(props.$useBrowserDefaultFocusStyle);
}, (0, _index.rootStyle)(), (0, _index.cssBorderRadius)('base', '4px'), function (props) {
  return getTextareaBlockPadding(props.$size);
}, function (props) {
  return (0, _index.getFormPaddingInline)(props.$size);
}, function (props) {
  return (0, _index.formControlTheme)({
    isUsingKeyboard: props.$isUsingKeyboard,
    isHover: props.$isHover,
    isFocus: props.$isFocus,
    error: props.$error,
    useBrowserDefaultFocusStyle: props.$useBrowserDefaultFocusStyle
  });
});